<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer001">
<p style="text-align:center;max-width:100%;"><img alt="A diagram of a family tree" src="image/Image1084.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// familytree.vue?b450ebe8